import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IPendencyInventoryDetailsPayload } from '../../../types';

/**
 * This key is used to track useTransferListQuery
 */
export const TRANSFER_PENDENCIES_DETAILS_PACKAGES_QUERY_KEY =
  'transfer-pendencies-details-packages-query-key';

/**
 * This hook fetches the transfer pendency details inventories with pagination.
 */
export const useFetchTransferPendencyDetailsInventories = (
  payload: IPendencyInventoryDetailsPayload & { limit: number }
) => {
  const { inventoryTransferType, trayId, limit } = payload;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      TRANSFER_PENDENCIES_DETAILS_PACKAGES_QUERY_KEY,
      inventoryTransferType,
      trayId,
      limit,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      INV_MGMT_SERVICE_API.getPendencyPackages({
        ...payload,
        page: pageParam,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;
      return currentCount < (lastPage?.total || 0) ? nextPage : undefined;
    },
  });

  // Flatten the paginated data
  const inventories =
    data?.pages.flatMap((page) => page?.inventories || []) || [];

  return {
    inventories,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isError,
    isPending,
    error,
    refetch,
  };
};
